import { computed, Ref } from 'vue';
import NotFoundError from '@/domain/errors/NotFoundError';
import UnknownError from '@/domain/errors/UnknownError';
import UnauthorizedError from '@/domain/errors/UnauthorizedError';
import LoginInvalidError from '@/domain/errors/LoginInvalidError';
import TwoStepRequiredError from '@/domain/errors/TwoStepRequiredError';
import EmailCodeMismatch from '@/domain/errors/EmailCodeMismatch';
import EmailInUseError from '@/domain/errors/EmailInUseError';
import EmailNotConfirmedError from '@/domain/errors/EmailNotConfirmed';
import EmailAlreadyConfirmed from '@/domain/errors/EmailAlreadyConfirmed';
import EmailConfirmationExpired from '@/domain/errors/EmailConfirmationExpired';
import EmailConfirmationCooldown from '@/domain/errors/EmailConfirmationCooldown';
import EmailCodeConfirmationInvalid from '@/domain/errors/EmailCodeConfirmationInvalid';
import MaxAttemptsReach from "@/domain/errors/MaxAttemptsReach";
import TokenExpiredError   from "@/domain/errors/TokenExpiredError";
import AwaitRetryError from "@/domain/errors/AwaitRetryError";
import InvalidCodeError from "@/domain/errors/InvalidCodeError";

type ClassError = new (message?: string) => Error;

const ErrorMap = new Map<ClassError['name'], string>([
  [NotFoundError.name, 'リソースが見つかりません'],
  [UnknownError.name, '不明なエラー'],
  [UnauthorizedError.name, '無許可'],
  [LoginInvalidError.name, 'メールアドレスまたはログインパスワードが無効です'],
  [TwoStepRequiredError.name, '2段階認証が必要です'],
  [EmailCodeMismatch.name, 'メールで送信されたコードは無効です'],
  [EmailInUseError.name, 'メール使用エラー'],
  [EmailCodeConfirmationInvalid.name, '暗証番号が違います'],
  [EmailNotConfirmedError.name, 'メールはまだ確認されていません。受信トレイを確認してください'],
  [EmailAlreadyConfirmed.name, '電子メールはすでに確認されているか、システムに存在しません'],
  [EmailConfirmationExpired.name, '有効期限が切れました。「メールを再送」を押してください。'],
  [EmailConfirmationCooldown.name, '試行回数が多すぎます。しばらくお待ちください'],
  [MaxAttemptsReach.name, '入力回数が上限を超えました。「メールを再送」を押してください。'],
  [TokenExpiredError.name, 'トークンの有効期限が切れました'],
  [AwaitRetryError.name, 'リトライしてください'],
  [InvalidCodeError.name, '無効なコードです'],
]);

export default function useErrorTranslate(errorRef: Ref<Error | null | undefined>) {
  return computed(() => {
    const error = errorRef.value;
    if (!error) return '';
    const translateError = ErrorMap.get(error.constructor.name);
    return translateError || error.message;
  });
}
